import { Grid, Typography } from '@mui/material';
import useCommonStyles from '../../../../../../commonStyles';
import SwitchInput from '../../../../../../Components/SwitchInput';
import InputConfig from '../../../../../../Components/InputConfig';
import { useContext } from 'react';
import { ConfigContext } from '../../../../../../Contexts/ConfigContext';

export default function AutoRemapModal({ keyData }) {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	return (
		<Grid
			container
			spacing={2}
			className={commonStyleClasses.modalContentStyle}
			style={{ overflowY: 'scroll', maxHeight: '50rem', padding: '2rem' }}
		>
			<Typography variant="h5" color="primary" fontWeight="600" marginLeft={'2rem'}>
				Auto Remap Configurations
			</Typography>
			<Grid
				item
				xs={12}
				style={{
					display: 'flex',
					gap: '2rem',
					flexDirection: 'column',
					justifyContent: 'center'
				}}
			>
				<SwitchInput
					label="Enabled"
					keyData={keyData + '.enabled'}
					defaultChecked={false}
					object={rawConfig}
					updateObject={updateRawConfig}
					containerStyles={{ width: '100%' }}
				/>
				<InputConfig
					keyData={keyData + '.interval'}
					label="Interval (in days)"
					object={rawConfig}
					updateObject={updateRawConfig}
					containerStyles={{ width: '70%' }}
					editable={!!rawConfig[keyData + '.enabled']}
					inputType="number"
				/>
			</Grid>
		</Grid>
	);
}
